import { getColorResolver, getResponsiveFactorSizeResolver } from '../../resolvers/CurryingResolvers';
export default function resolveBorder(theme, screenWidth, borderSupport) {
    var result = {};
    var borderSizeResolver = function (borderSize) {
        var resolved = getResponsiveFactorSizeResolver(theme, theme.designGrid.borderRadius, screenWidth)(borderSize);
        if (typeof resolved === 'number') {
            return Math.round(resolved);
        }
        return resolved;
    };
    var borderRadiusResolver = getResponsiveFactorSizeResolver(theme, theme.designGrid.borderRadius, screenWidth);
    var colorResolver = getColorResolver(theme, screenWidth);
    var useBorderStyle = false;
    //#region border
    if (borderSupport.border !== undefined) {
        result.borderWidth = borderSizeResolver(borderSupport.border);
        useBorderStyle = true;
    }
    if (borderSupport.borderTopBottom !== undefined) {
        var borderTopBottom = borderSizeResolver(borderSupport.borderTopBottom);
        result.borderTopWidth = borderTopBottom;
        result.borderBottomWidth = borderTopBottom;
        useBorderStyle = true;
    }
    if (borderSupport.borderRightLeft !== undefined) {
        var borderRightLeft = borderSizeResolver(borderSupport.borderRightLeft);
        result.borderRightWidth = borderRightLeft;
        result.borderLeftWidth = borderRightLeft;
        useBorderStyle = true;
    }
    if (borderSupport.borderTop !== undefined) {
        result.borderTopWidth = borderSizeResolver(borderSupport.borderTop);
        useBorderStyle = true;
    }
    if (borderSupport.borderBottom !== undefined) {
        result.borderBottomWidth = borderSizeResolver(borderSupport.borderBottom);
        useBorderStyle = true;
    }
    if (borderSupport.borderRight !== undefined) {
        result.borderRightWidth = borderSizeResolver(borderSupport.borderRight);
        useBorderStyle = true;
    }
    if (borderSupport.borderLeft !== undefined) {
        result.borderLeftWidth = borderSizeResolver(borderSupport.borderLeft);
        useBorderStyle = true;
    }
    //#endregion
    //#region borderColor
    if (borderSupport.borderColor !== undefined) {
        result.borderColor = colorResolver(borderSupport.borderColor);
    }
    if (borderSupport.borderColorTopBottom !== undefined) {
        var borderColorTopBottom = colorResolver(borderSupport.borderColorTopBottom);
        ;
        result.borderTopColor = borderColorTopBottom;
        result.borderBottomColor = borderColorTopBottom;
    }
    if (borderSupport.borderColorRightLeft !== undefined) {
        var borderColorRightLeft = colorResolver(borderSupport.borderColorRightLeft);
        ;
        result.borderRightColor = borderColorRightLeft;
        result.borderLeftColor = borderColorRightLeft;
    }
    if (borderSupport.borderColorTop !== undefined) {
        result.borderTopColor = colorResolver(borderSupport.borderColorTop);
    }
    if (borderSupport.borderColorBottom !== undefined) {
        result.borderBottomColor = colorResolver(borderSupport.borderColorBottom);
    }
    if (borderSupport.borderColorRight !== undefined) {
        result.borderRightColor = colorResolver(borderSupport.borderColorRight);
    }
    if (borderSupport.borderColorLeft !== undefined) {
        result.borderLeftColor = colorResolver(borderSupport.borderColorLeft);
    }
    //#endregion
    //#region borderRadius
    if (borderSupport.borderRadius !== undefined) {
        result.borderRadius = borderRadiusResolver(borderSupport.borderRadius);
    }
    if (borderSupport.borderRadiusTopLeft !== undefined) {
        result.borderTopLeftRadius = borderRadiusResolver(borderSupport.borderRadiusTopLeft);
    }
    if (borderSupport.borderRadiusTopRight !== undefined) {
        result.borderTopRightRadius = borderRadiusResolver(borderSupport.borderRadiusTopRight);
    }
    if (borderSupport.borderRadiusBottomLeft !== undefined) {
        result.borderBottomLeftRadius = borderRadiusResolver(borderSupport.borderRadiusBottomLeft);
    }
    if (borderSupport.borderRadiusBottomRight !== undefined) {
        result.borderBottomRightRadius = borderRadiusResolver(borderSupport.borderRadiusBottomRight);
    }
    //#endregion
    //#region borderStyle
    if (useBorderStyle) {
        if (borderSupport.borderStyle) {
            result.borderStyle = borderSupport.borderStyle;
        }
        else {
            result.borderStyle = 'solid';
        }
    }
    //#endregion
    return result;
}
//# sourceMappingURL=BorderResolver.js.map